/**
 * Dati del marchio e contatti mostrati nell'interfaccia.
 * Fonte: sito ufficiale DS Consulting.
 *
 * PENDING: `siteUrl` e `contactEmail` saranno collegati al nuovo sito e alla nuova casella
 * email. Finché sono vuoti, i relativi link non vengono mostrati.
 */
export const BRAND = {
  productName: 'Motore Gare DS',
  companyName: 'DS Consulting',
  legalName: 'DS Consulting di Dello Stritto Francesco & C. s.a.s.',
  vatNumber: '04113560611',
  address: 'Via Giovanni Gentile 12, Caserta',
  privacyEmail: 'info@dsconsultingsas.it',
  phone: '+39 335 129 7366',

  // PENDING: nuovo sito e nuova casella email
  siteUrl: '',
  contactEmail: '',

  social: {
    linkedin: 'https://www.linkedin.com/company/ds-consulting-consulenza-appalti-pubblici/',
    whatsapp: 'https://wa.me/393351297366',
  },
};

export default BRAND;
